import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import BotbWinPage from "../app/(custom-header)/win/page";

const root = createRoot(document.getElementById("botb-win-page-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <BotbWinPage />
    </StoreProvider>
  </React.StrictMode>
);
